module.exports = __webpack_public_path__ + "static/img/day.f9f0a85b.svg";